import { api, devAgentAuthHeaders, unwrap, withUserId } from "./core";

interface FeedbackPayload {
  session_id: number;
  message_id: string;
  score: number;
  query: string;
  org_id?: string;
}

export const submitFeedback = async (payload: FeedbackPayload): Promise<void> => {
  await api.post("/api/feedback", payload, {
    headers: devAgentAuthHeaders(payload.org_id),
  });
};

export const searchMetadata = async (params: {
  query: string;
  org_id: string;
  types?: string[];
  limit?: number;
}): Promise<{
  results: Array<{
    id: string;
    name: string;
    type: string;
    snippet: string;
    match_score: number;
    last_modified?: string | null;
    modified_by?: string | null;
  }>;
  total: number;
  facets: Record<string, number>;
}> =>
  unwrap(
    (
      await api.post("/api/search", params, {
        timeout: 15000,
        headers: devAgentAuthHeaders(params.org_id),
      })
    ).data,
  );

export const resetOrgContext = async (params: {
  old_org_id?: string | null;
  new_org_id?: string | null;
}): Promise<void> => {
  try {
    await api.post(withUserId("/api/chat/reset-org-context"), params, {
      timeout: 10000,
      headers: devAgentAuthHeaders(params.new_org_id ?? params.old_org_id),
    });
  } catch (error) {
    console.warn("[resetOrgContext] failed:", error);
  }
};
